export const buildUrlWithQueryParams = (basePath, params) => {
  const queryObj = new URLSearchParams(params);

  return `${basePath}?${queryObj.toString()}`;
}
